<template>
    <div ref="pipelineReport">
        <b-card no-body>
            <b-tabs card>
                <!-- Pipeline Results -->
                <b-tab title="Pipeline results" active>
                    <data-list-pagination :dataCols="pipelineHistoryCols"
                                          :dataListItems="selectedClaim.pipelineRunHistoryDetails"
                                          :tableClass="'table table-striped table-sm'"
                                          @dbl-click="handleHistoryItemDblClick"
                                          @pagination-input="handlePipelineRunHistoryPagenationInput " />

                    <b-tabs card v-if="selectedPipelineHistory != null">
                        <b-tab title="Result" active>

                            <data-list :dataCols="selectedPipelineHistoryCols"
                                       :dataListItems="selectedPipelineHistoryRules"
                                       :tableClass="'table table-striped table-sm'" />
                        </b-tab>
                        <b-tab title="Result v2" active>
                            <div class="mb-3">
                                <i class="far fa-circle" style="color: darkorange"></i> Rule not run
                                <i class="far fa-check-circle" style="color: green"></i> Rule passed
                                <i class="far fa-times-circle" style="color: red"></i> Rule failed
                            </div>
                            <hr />
                            <div class="row mb-2" v-for="(rule, index) in selectedPipelineHistoryRules">
                                <div class="col">
                                    <collapsible-card :initCollapsed="true">
                                        <h5 slot="title">{{rule.RuleName}}</h5>
                                        <div slot="body">
                                            <hr />
                                            <json-viewer v-model="selectedPipelineHistoryRules[index]"
                                                         :viewMode="0" />
                                        </div>
                                    </collapsible-card>

                                </div>
                                <div class="col-4">
                                    <i v-if="rule.StatusText == 'NOT_RUN'" class="far fa-circle fa-3x" style="color: darkorange"></i>
                                    <i v-if="rule.StatusText == 'PASSED'" class="far fa-check-circle fa-3x" style="color: green"></i>
                                    <i v-if="rule.StatusText == 'FAILED'" class="far fa-times-circle fa-3x" style="color: red"></i>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="JSON">

                            <json-viewer v-model="selectedPipelineHistoryRules"
                                         :viewMode="0" />

                        </b-tab>
                    </b-tabs>
                </b-tab>
                <!-- Documents -->
                <b-tab title="Documents">
                    <b-card no-body>
                        <b-tabs card>
                            <b-tab title="Claim Uploads">
                                <p><i class="fas fa-info-circle mr-2"></i>Clicking on the document preview will open / download the file.  If the preview is not showing correctly then there may be an issue with the document and you should ask the customer to check and upload again.</p>
                                <div v-if="selectedClaim.documentDetails && selectedClaim.documentDetails.length > 0">
                                    <div v-for="document in selectedClaim.documentDetails" :key="document.id" class="row mt-3">
                                        <div class="col-sm-6">
                                            <p><strong>Document type:</strong> {{document.documentTypeLabel}}</p>
                                            <p><strong>Date uploaded:</strong> {{document.dateCreated}}</p>
                                            <p><strong>Original filename:</strong> {{document.originalFilename}}</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <a href="javascript:void(0);" @click="handleDocumentLinkClick(document.id)">
                                                <img-with-key v-if="document.mimeType && document.mimeType.includes('image')"
                                                              :imgsrc="documentUrl + document.id"
                                                              :imgclass="'img-thumbnail'" />

                                                <pdf-viewer-with-key v-else-if="document.mimeType && document.mimeType.includes('pdf')"
                                                                     :viewerclass="'img-thumbnail'"
                                                                     :viewerurl="documentUrl + document.id">
                                                </pdf-viewer-with-key>

                                                <span v-else>Click to download</span>
                                            </a>
                                        </div>
                                    </div>
                                    <b-pagination v-if="documentsTotalRecords > documents.pageSize"
                                                  class="mt-3"
                                                  align="center"
                                                  :total-rows="documentsTotalRecords"
                                                  :per-page="documents.pageSize"
                                                  :size="'sm'"
                                                  @input="handleDocumentsPaginationInput" />
                                </div>
                                <div v-else>
                                    <div v-if="claimDocumentsLoading == true" class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>No documents have been uploaded...</span>
                                </div>
                            </b-tab>
                            <b-tab title="Sales Uploads">
                                <p><i class="fas fa-info-circle mr-2"></i>Clicking on the document preview will open / download the file.</p>
                                <div v-if="salesDocumentUploads && salesDocumentUploads.length > 0">
                                    <div v-for="document in salesDocumentUploads" :key="document.id" class="row mt-3">
                                        <div class="col-sm-6">
                                            <p><strong>Date uploaded:</strong> {{document.createdDate}}</p>
                                            <p><strong>Original filename:</strong> {{document.originalFileName}}</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <a v-if="document.fileType.includes('image')" :href="salesDocumentUrl + document.id" target="_blank">
                                                <img :src="salesDocumentUrl + document.id"
                                                     class="img-thumbnail">
                                            </a>
                                            <div v-else>
                                                <a :href="salesDocumentUrl + document.id" target="_blank">
                                                    <pdf-viewer class="img-thumbnail" :url="salesDocumentUrl + document.id"></pdf-viewer>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <span>No documents have been uploaded...</span>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>

                <!-- Excess Calculations -->
                <b-tab title="Excess Calculations">
                    <data-list :dataCols="excessCalculationCols"
                               :dataListItems="selectedClaim.excessCalculations"
                               :tableClass="'table table-striped table-sm'"
                               @dbl-click="handleExcessCalculationItemDblClick" />
                    <b-tabs card v-if="selectedExcessCalculation != null">

                        <b-tab title="JSON">
                            <simple-display-grid key="selectedExcessPaymentCalc"
                                                 :columnCount="1"
                                                 :inputs="selectedExcessPaymentInputs"
                                                 :values="selectedExcessCalculation" />
                        </b-tab>
                    </b-tabs>
                </b-tab>
                <!-- Claim Status History -->
                <b-tab title="Status History">
                    <data-list-pagination :dataCols="claimStatusHistoryCols"
                                          :dataListItems="selectedClaim.claimStatusDetails"
                                          :tableClass="'table table-striped table-sm'"
                                          @pagination-input="handleStatusHistoryPagenationInput" />
                </b-tab>
                <!-- Claim Email History -->
                <b-tab title="Email History">
                    <data-list-pagination :dataCols="claimEmailHistoryCols"
                                          :dataListItems="selectedClaim.emailHistoryDetails"
                                          :tableClass="'table table-striped table-sm'"
                                          @dbl-click="handleEmailHistoryItemDblClick"
                                          @pagination-input="handleEmailHistoryPagenationInput" />

                    <b-tabs card v-if="selectedEmailHistoryItem != null">

                        <b-tab title="Body">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe class="embed-responsive-item"
                                        :src="getBlobURL(selectedEmailHistoryItem.messageBody, 'text/html')"></iframe>
                            </div>

                        </b-tab>
                    </b-tabs>
                </b-tab>
                <!-- Claim Policy Refresh History -->
                <b-tab title="Claimant Refresh History">
                    <data-list :dataCols="claimPolicyRefreshHistoryCols"
                               :dataListItems="selectedClaim.claimPolicyRefreshDetails"
                               :tableClass="'table table-striped table-sm'" />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>

    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import DataList from '@/components/DataList.vue'
    import DataListPagination from '@/components/DataListPagination.vue'
    import RequestMoreDocs from '@/components/RequestMoreDocs.vue'
    import PdfViewer from '@/components/pdf-viewer/PdfViewer.vue'
    import JsonViewer from '@/components/jsonViewer.vue'
    import CollapsibleCard from '@/components/CollapsibleCard.vue'
    import imgWithKey from '@/components/imgWithKey.vue'
    import pdfViewerWithKey from '@/components/pdfViewerWithKey.vue'

    import { mapActions } from 'vuex'

    import { selectedPipelineHistoryInputs } from '@/ui.config/inputs/selectedPipelineHistoryInputs'
    import { selectedExcessPaymentInputs } from '@/ui.config/inputs/selectedExcessPaymentInputs'

    import { excessPaymentsCols } from '@/ui.config/cols/excessPaymentsCols'
    import { excessCalculationCols } from '@/ui.config/cols/excessCalculationCols'
    import { pipelineHistoryCols } from '@/ui.config/cols/pipelineHistoryCols'
    import { selectedPipelineHistoryCols } from '@/ui.config/cols/selectedPipelineHistoryCols'
    import { claimStatusHistoryCols } from '@/ui.config/cols/claimStatusHistoryCols'
    import { claimEmailHistoryCols } from '@/ui.config/cols/claimEmailHistoryCols'
    import { claimPolicyRefreshHistoryCols } from '@/ui.config/cols/claimPolicyRefreshHistoryCols'

    import { flatten } from '@/util/flatten'

    import { reportsApiService } from '@/services/reports-api.service.js'

    export default {
        name: 'ClaimApprovePopoutTabs',
        components: {
            SimpleDisplayGrid,
            RequestMoreDocs,
            DataList,
            DataListPagination,
            PdfViewer,
            'json-viewer': JsonViewer,
            'collapsible-card': CollapsibleCard,
            'img-with-key': imgWithKey,
            'pdf-viewer-with-key': pdfViewerWithKey
        },
        data: () => {
            return {
                excessPaymentsCols: excessPaymentsCols,
                pipelineHistoryCols: pipelineHistoryCols,
                selectedPipelineHistoryCols: selectedPipelineHistoryCols,
                selectedPipelineHistoryInputs: selectedPipelineHistoryInputs,
                selectedExcessPaymentInputs: selectedExcessPaymentInputs,
                excessCalculationCols: excessCalculationCols,
                claimStatusHistoryCols: claimStatusHistoryCols,
                claimEmailHistoryCols: claimEmailHistoryCols,
                claimPolicyRefreshHistoryCols: claimPolicyRefreshHistoryCols,

                selectedPipelineHistory: null,
                selectedPipelineHistoryRules: null,

                selectedExcessPayment: null,

                selectedOnsiteBooking: null,

                selectedExcessCalculation: null,

                selectedEmailHistoryItem: null,

                emailHistory: {
                    pageNumber: 1,
                    pageSize: 10
                },

                statusHistory: {
                    pageNumber: 1,
                    pageSize: 10
                },

                pipelineRunHistory: {
                    pageNumber: 1,
                    pageSize: 10
                },

                documents: {
                    pageNumber: 1,
                    pageSize: 10
                },

                docDownloadKeys: [
                    {
                        documentId: null,
                        key1: null,
                        key2: null
                    }
                ],

                gotKeys: false
            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            documentUrl() {
                return '/api/admin/v1/document/download/'
            },
            salesDocumentUrl() {
                return '/api/admin/v1/document/sales/download/'
            },
            emailHistoryTotalRecords() {
                if (this.selectedClaim.emailHistoryDetails[0]) {
                    return this.selectedClaim.emailHistoryDetails[0].totalRecords
                }
            },
            documentsTotalRecords() {
                return this.selectedClaim.documentDetails[0].totalRecords
            },
            salesDocumentUploads() {
                return this.$store.getters.salesDocumentUploads
            },
            claimDocumentsLoading() {
                return this.$store.getters.claimDocumentsLoading
            }
        },
        mounted() {
            /* */
        },
        methods: {
            ...mapActions([
                'requestMoreDocs',
                'fetchEmailHistoryClaim',
                'fetchStatusHistoryClaim',
                'fetchPipelineRunHistoryClaim',
                'fetchDocumentsClaim'
            ]),
            handleHistoryItemDblClick(payload) {
                this.selectedPipelineHistory = payload
                let { result } = this.selectedPipelineHistory
                result = JSON.parse(result)
                this.selectedPipelineHistoryRules = []
                for (let i = 0; i < result.length; i++) {
                    this.selectedPipelineHistoryRules.push(flatten(result[i]))
                }
            },
            handleExcessPaymentItemDblClick(payload) {
                this.selectedExcessPayment = payload
            },
            handleExcessCalculationItemDblClick(payload) {
                this.selectedExcessCalculation = payload
            },
            handleEmailHistoryItemDblClick(payload) {
                this.selectedEmailHistoryItem = payload
            },
            getBlobURL(code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            },
            handleDocumentTypeClick(item) {
                if (this.selectedDocumentTypes.includes(item)) {
                    this.selectedDocumentTypes.splice(this.selectedDocumentTypes.indexOf(item), 1)
                } else {
                    this.selectedDocumentTypes.push(item)
                }
            },
            handleEmailHistoryPagenationInput(payload) {
                this.emailHistory.pageNumber = payload
                this.searchEmailHistory()
            },
            searchEmailHistory() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this.emailHistory

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchEmailHistoryClaim(criteria)
            },
            handleStatusHistoryPagenationInput(payload) {
                this.statusHistory.pageNumber = payload
                this.searchStatusHistory()
            },
            searchStatusHistory() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this.statusHistory

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchStatusHistoryClaim(criteria)
            },
            handlePipelineRunHistoryPagenationInput(payload) {
                this.pipelineRunHistory.pageNumber = payload
                this.selectedPipelineHistory = null
                this.selectedPipelineHistoryRules = []
                this.searchPipelineRunHistory()
            },
            searchPipelineRunHistory() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this.pipelineRunHistory

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    relatedId: claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchPipelineRunHistoryClaim(criteria)
            },
            handleDocumentsPaginationInput(payload) {
                if (payload) {
                    this.documents.pageNumber = payload
                    this.searchDocuments()
                }
            },
            searchDocuments() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this.documents

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchDocumentsClaim(criteria)
            },
            getDocumentDownloadUrlWithKey(id, keyNum) {
                let doc = this.docDownloadKeys.find(d => d.documentId = id)
                if (doc) {
                    if (keyNum == 1) {
                        return doc.key1
                    } 

                    if (keyNum == 2) {
                        return doc.key2
                    } 
                }
                return 'null'
            },
            handleDocumentLinkClick(payload) {
                reportsApiService.getDownloadKey()
                    .then( response => {
                        window.open(
                            this.documentUrl + payload + '/' + response.data,
                            '_blank'
                        )
                    })
            },
        }
    }
</script>